module.exports = __webpack_public_path__ + "img/庆云签约列表图.970f20a9.png";